export const DEFAULT_INDENT_WIDTH = 20;
export const MINI_INDENT_WIDTH_STRING = '10px';
export const DEFAULT_ROWS_GAP = 10;